import moment from 'moment';
import { navigate } from 'hookrouter'
import { handleRemoveLecture } from './requests/LectureRequests';

export async function RemoveLecture(id, dispatch, courseId) {
    var response = await handleRemoveLecture(id);
    if (response.success) {
        dispatch({ type: 'SHOW_DELETED_TOAST' });
    }
    else {
        dispatch({ type: 'SHOW_ERROR_TOAST' });
    }
    return navigate('/exlCourseDetails/' + courseId);
}

export function ValidateTimes(startTime, endTime) {
    if (startTime >= endTime || endTime <= startTime)
        return false
    return true;
}

export function CreateDateObject(date, startTime, endTime) {
    return {
        from: `${moment(date).format('YYYY-MM-DD')}T${moment(startTime).format('HH:mm')}`,
        to: `${moment(date).format('YYYY-MM-DD')}T${moment(endTime).format('HH:mm')}`
    }
}
